import React, { useState } from "react";
import { formatDate, formatValidSelect } from "../../../helpers/FormatHelper";
import { getStyle } from "../../../styles/styles";
import DatePicker from "../../shared/DatePicker";
import NewEditableGrid from "../../shared/NewEditableGrid";
import ReconciliationBankNotesForm from "./ReconciliationBankNotesForm";
import ReconciliationBankNotesProvider from "./ReconciliationBankNotesProvider";
import { useContext } from "react";
import ReconciliationBankNotesContext from "./ReconciliationBankNotesContext";
import { deleteVaultReconciliation } from "../../../networking/NetworkingBankNotes";
import { getBNVaultBalances } from "../../../networking/NetworkingOrders";

const style = getStyle();


const ReconciliationBankNotesScreenContent = () => {

    const {
        data,
        columnDetails,
        dateReported,
        setDateReported,
        page,
        setPage,
        vaultSelected,
        setVaultSelected,
        setVaultReconciliationRecord,
        loadVaultReconciliation,
        alreadyReconciliated,
        reload,
        alertMessage,
        setAlertMessage,
        confirmationMessage,
        setConfirmationMessage,
        isBankNotesAdmin,        
        setLoading,
        currencyDenominations,
        defaultReconciliation
    } = useContext(ReconciliationBankNotesContext);

    const vaultOptions = [
        { value: "-1", name: "Select a vault ..." },
        { value: "1", name: "Main office" },
    ];
    const [validations, setValidations] = useState({
        vault: true,
    });

    const validateForm = () => {
        let newValidations = { ...validations };
        if (Number(vaultSelected.id) > 0) {
            newValidations.vault = true;
        } else {
            newValidations.vault = false;
        }
        setValidations(newValidations);
        return newValidations.vault;
    };

    const addNewReconciliation = async () => {
        if (validateForm()) {
            const reconciliationId = alreadyReconciliated()
            if (reconciliationId > 0) {
                loadReconciliation({ VaultReconciliationID: reconciliationId })
            }
            else {

                let newReconciliationItems = [];
                defaultReconciliation.forEach(d => {
                    const currencyDetails = currencyDenominations.find(
                        (c) => c.CurrencyID === d.CurrencyID
                    );
                    if (currencyDetails && currencyDetails.Denominations) {
                        let item = { CurrencyID: currencyDetails.CurrencyID, ReportedValue: 0, ReconciliationDenominations: currencyDetails.Denominations };
                        newReconciliationItems.push(item);
                    }
                });

                if (isBankNotesAdmin) {
                    setLoading(true)
                    const balancesResponse = await getBNVaultBalances({ vaultId: vaultSelected.id });
                    console.log('balances', balancesResponse)
                    setLoading(false)

                    if (balancesResponse && Array.isArray(balancesResponse.result) && balancesResponse.result.length > 0) {
                        const balances = balancesResponse.result
                        newReconciliationItems.forEach(item => {
                            const balanceForItemCurrency = balances.filter(b => b.Currency === item.CurrencyID)
                            if (balanceForItemCurrency && balanceForItemCurrency.find(bc => Number(bc['In Stock']) > 0)) {
                                console.log('balanceForItemCurrency', balanceForItemCurrency)
                                item.ReconciliationDenominations = balanceForItemCurrency.map(b => {
                                    return {
                                        DenominationDescription: b['Denomination Description'],
                                        InventoryNoNotes: Number(b['In Stock']),
                                        ReportedNoNotes: 0,
                                        DenominationValue: Number(b['Denomination Description'])
                                    }
                                })
                            }
                        })
                    }
                }
                setPage("form");
                setVaultReconciliationRecord({
                    VaultReconciliationID: 0,
                    VaultID: vaultSelected.id,
                    DateReported: dateReported,
                    ReportingUserID: localStorage.getItem("UserID"),
                    Status: "In Progress",
                    UpdateToken: "",
                    ReconciliationItems: newReconciliationItems,
                });
            }
        };
    }

    const loadReconciliation = (record) => {
        loadVaultReconciliation(record.VaultReconciliationID);
        setPage("form");
    }

    const onBack = () => {
        setPage("list");
        loadVaultReconciliation(0);
        reload()
    } 

    const handleDeleteClick = (rec) => {
        console.log('rec', rec)        
        setConfirmationMessage({
            ...confirmationMessage, show: true, title: 'Confirm',
            message: `Please confirm if reconciliation for the date ${rec.DateReported} will be deleted.`,
            callback: deleteReconciliation,
            callbackParams: [rec.VaultReconciliationID, rec.UpdateToken]
        })
    }

    const deleteReconciliation = async (vaultReconciliationId, updateToken) => {        

        console.log('deleteReconciliation params', vaultReconciliationId, updateToken)

        setLoading(true)
        const response = await deleteVaultReconciliation(vaultReconciliationId, updateToken);
        setLoading(false)
        console.log('deleteVaultReconciliation', response)

        if (response && response.success) {
            setAlertMessage({ ...alertMessage, show: true, title: 'Sucess', message: `Reconciliation deleted successfully` })            
            reload()
        } else {
            setAlertMessage({
                ...alertMessage, show: true, title: 'Error',
                message: response !== undefined
                    ? response.Message
                    : 'Something went wrong. Please try again later.'
            })
        }
    }

    switch (page) {
        case "form":
            return <ReconciliationBankNotesForm back={onBack} isBankNotesAdmin={isBankNotesAdmin} />;
        default:
            return (
                <>
                    <h3 className="uk-heading-divider" style={style.titleStyle}>
                        Reconciliation Bank Notes
                    </h3>
                    <div className="uk-grid">
                        <div className="uk-width-1-8">
                            <div className="uk-margin">
                                <label className="uk-form-label">Date Reported</label>
                                <div className="uk-form-controls">
                                    <DatePicker
                                        id={"dp-bos-fromdate"}
                                        key={"dp-bos-fromdate"}
                                        className="uk-input"
                                        style={style.inputStyle}
                                        value={dateReported}
                                        onDayChange={(date) => {
                                            const _date = formatDate(date);
                                            setDateReported(_date);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="uk-width-1-4">
                            <div className="uk-margin">
                                <label className="uk-form-label">Vaults</label>
                                <div className="uk-form-controls">
                                    <select
                                        id="vault-rc-sel-vault"
                                        className={formatValidSelect(validations.vault)}
                                        value={vaultSelected.id}
                                        onChange={(e) => {                                            
                                            setVaultSelected({
                                                name: e.target.selectedOptions[0].text,
                                                id: e.target.value,
                                            });
                                        }}
                                    >
                                        {vaultOptions.map((type) => (
                                            <option
                                                key={`status-option-${type.value}`}
                                                value={type.value}
                                            >{`${type.name}`}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="uk-width-1-8 uk-margin">
                            <button
                                className="uk-button uk-button-green"
                                type="button"
                                onClick={() => {
                                    addNewReconciliation();
                                }}
                            >
                                Reconciliate
                            </button>
                        </div>
                    </div>
                    <hr />
                    <NewEditableGrid
                        id="grid-vault-reconciliation"
                        data={data}
                        columnDetails={columnDetails}
                        isEditable={false}
                        tableName={"vault-reconciliation"}
                        useExportButton={true}
                        enableClick={true}
                        clickFunction={(record) => {                            
                            loadReconciliation(record);
                        }}
                        useDeleteButton={isBankNotesAdmin}
                        deleteFunction={handleDeleteClick}
                        useIcons={true}
                    />
                </>
            );
    }
};

const ReconciliationBankNotesScreen = () => {
    return (
        <ReconciliationBankNotesProvider>
            <ReconciliationBankNotesScreenContent />
        </ReconciliationBankNotesProvider>
    );
};

export default ReconciliationBankNotesScreen;
